import React from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./app";
import { initSentry } from "./sentry";

initSentry();

/**
 * Entry point of the React application.
 * Renders the main App component into the DOM.
 */
const container = document.getElementById("root");
const root = createRoot(container);
const GOOGLE_CLIENT_ID =
  "883366660684-rndklu37oqafv5t7ie5htq9qtn93570s.apps.googleusercontent.com"; // Replace with your actual Google Client ID

root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);
